import * as sidebarItems from "../config/sidebar/admin-sidebar.json";
class AdminUtil {
    static getSidebarItems() {
        return sidebarItems.default;
    }
}

export default AdminUtil;
